module.exports = __webpack_public_path__ + "img/main-icon-1.6e87259f.svg";